import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Text, Modal } from "$components";
import useURLQuery from "$hooks/useURLQuery";
import useJStyles from "$hooks/useJStyles";

export const ModalCreated = () => {
  const [isEdbCreated, setIsEdbCreated] = useState(false);
  const urlQuery = useURLQuery();
  const { jclasses } = useJStyles();

  const handleValidateDialog = () => {
    setIsEdbCreated(false);
  };

  useEffect(() => {
    if (urlQuery.get("created") || urlQuery.get("updated")) {
      setIsEdbCreated(true);
    }
  }, [urlQuery]);

  if (!isEdbCreated) {
    return null;
  }

  return (
    <Modal
      title="Expression de besoin validée"
      textValidate="OK"
      open={isEdbCreated}
      noCancelButton
      onValidate={handleValidateDialog}
      onCancel={handleValidateDialog}
    >
      <Box className={jclasses.jDialogContent}>
        <Text>{`${urlQuery.get("edbId")} créée avec succès.`}</Text>
        <br />
        <Text>
          Vous pourrez suivre l’expression de besoin depuis cette page à tout
          moment
        </Text>
      </Box>
    </Modal>
  );
};
